var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "equimentVersion" }, [
    _c("div", { staticClass: "equimentVersion-head" }, [
      _c("ul", [
        _c(
          "li",
          [
            _c("h5", [_vm._v("设备号")]),
            _vm._v(" "),
            _c("el-input", {
              model: {
                value: _vm.form.equipmentNumber,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "equipmentNumber", $$v)
                },
                expression: "form.equipmentNumber",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("h5", [_vm._v("逻辑版本号")]),
            _vm._v(" "),
            _c("el-input", {
              model: {
                value: _vm.form.logicVersion,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "logicVersion", $$v)
                },
                expression: "form.logicVersion",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("h5", [_vm._v("包名")]),
            _vm._v(" "),
            _c("el-input", {
              model: {
                value: _vm.form.packageName,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "packageName", $$v)
                },
                expression: "form.packageName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("h5", [_vm._v("类型")]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "请选择" },
                model: {
                  value: _vm.form.type,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "type", $$v)
                  },
                  expression: "form.type",
                },
              },
              _vm._l(_vm.types, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("h5", [_vm._v("更新方式")]),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "请选择" },
                model: {
                  value: _vm.form.updateType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "updateType", $$v)
                  },
                  expression: "form.updateType",
                },
              },
              _vm._l(_vm.updateTypes, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "function" }, [
      _c("ol", [
        _c("li", { on: { click: _vm.search } }, [
          _c("img", {
            attrs: { src: require("../../assets/iconfont/find.png"), alt: "" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v("查询")]),
        ]),
        _vm._v(" "),
        _c("li", { on: { click: _vm.empty } }, [
          _c("img", {
            attrs: { src: require("../../assets/iconfont/empty.png"), alt: "" },
          }),
          _vm._v(" "),
          _c("span", [_vm._v("清空")]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: { data: _vm.tableData, border: "" },
          },
          [
            _c("el-table-column", {
              attrs: { type: "index", index: _vm.indexMethod },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "equipmentNumber", label: "设备号" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "updateType",
                formatter: _vm.updateType,
                label: "更新方式",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "type",
                formatter: _vm.equimentType,
                label: "类型",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "logicVersion", label: "逻辑版本号" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "name", label: "应用名称" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "packageName", label: "包名" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "version", label: "版本号" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "versionNo", label: "内部版本号" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "opTime", label: "操作时间" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page" },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            layout: "total, prev, pager, next",
            "page-size": 10,
            total: _vm.total,
            "current-page": _vm.currentPage,
          },
          on: { "current-change": _vm.changepage },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }